module.exports = __webpack_public_path__ + "BradescoSans-Regular-DLFlD9oO.11497cb4b3a1b4b55da3.woff2";


//////////////////
// WEBPACK FOOTER
// /home/runner/_work/fini-sta-01-estatico-sitecliente/fini-sta-01-estatico-sitecliente/src/assets/fonts/bradesco/BradescoSans-Regular-DLFlD9oO.woff2
// module id = ../../../../../src/assets/fonts/bradesco/BradescoSans-Regular-DLFlD9oO.woff2
// module chunks = styles